<template>
    <div
      v-if="isVisible"
      class="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50"
    >
      <div
        class="relative bg-white rounded-lg shadow-lg max-h-[450px] max-w-[550px] w-full p-12"
      >
        <!-- Close button -->
        <button
          @click="closePopup"
          class="absolute top-6 right-8 text-gray-800 hover:text-gray-600"
        >
          <i class="pi pi-times" style="font-size: 0.75rem"></i>
        </button>
  
        <div class="flex flex-col items-center justify-content gap-10">
          <!-- SVG Icon -->
          <div class="mb-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="106"
              height="105"
              viewBox="0 0 106 105"
              fill="none"
            >
              <path
                d="M13.625 85.3125V22.9688C13.625 22.0985 13.9707 21.2639 14.5861 20.6486C15.2014 20.0332 16.036 19.6875 16.9063 19.6875H89.0938C89.964 19.6875 90.7986 20.0332 91.414 20.6486C92.0293 21.2639 92.375 22.0985 92.375 22.9688V85.3125L79.25 78.75L66.125 85.3125L53 78.75L39.875 85.3125L26.75 78.75L13.625 85.3125Z"
                stroke="#E7B75F"
                stroke-width="4.2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M62.8438 39.375L43.1562 59.0625"
                stroke="#E7B75F"
                stroke-width="4.2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M43.1562 39.375L62.8438 59.0625"
                stroke="#343330"
                stroke-width="4.2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
  
          <!-- Title -->
          <h2 class="text-2xl font-semibold mb-2 text-center">
            Payment Canceled. You can resume payment anytime.
          </h2>
          <!-- Buttons - Changed justify-center to justify-end -->
          <div class="flex justify-end gap-4 w-full">
            <button
              @click="cancelCampaignsButton"
              class="px-6 py-2.5 border border-solid w-45 h-12 border-black rounded-md hover:bg-gray-50 transition-colors"
            >
              Back to Campaigns
            </button>
            <button
              @click="resumePaymentPopup"
              class="px-6 py-2.5 bg-[#369DA3] text-white w-45 h-12 rounded-md hover:bg-teal-800 transition-colors flex items-center gap-2"
            >
              <i class="pi pi-plus" style="font-size: 0.75rem"></i>
              Resume Payment
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import store from "../../store";
  import router from "../../router/router";
  export default {
    data() {
      return {
        isVisible: true,
      };
    },
    methods: {
      resumePaymentPopup() {
        this.$emit('closePopup', 'paymentStatusCancel')
        store.commit('openReviewPayment');
      },
      cancelCampaignsButton() {
        this.$emit('closePopup', 'paymentStatusCancel');
        this.$router.push('/campaigns');
        this.$store.commit("restoreStat");
      },
    },
  };
  </script>
  
  <style>
  .parent-div {
    position: relative;
  }
  </style>
  